import { render, staticRenderFns } from "./_cv-code-snippet-inline.vue?vue&type=template&id=5df7c89e&"
import script from "./_cv-code-snippet-inline.vue?vue&type=script&lang=js&"
export * from "./_cv-code-snippet-inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports